import React from 'react';
import PropTypes from 'prop-types';
import './checkbox-group.scss';
import clsx from 'clsx';
import CheckboxGroupItem from './checkbox-group-item';

const CheckboxGroup = ({
  items, onSelect, showSelect, className,
}) => {
  const getView = () => (
    items.map(({
      id, renderIcon, image, text, supportingText, disabled, selected,
    }) => (
      <CheckboxGroupItem
        itemId={id}
        key={id}
        renderIcon={renderIcon}
        image={image}
        text={text}
        supportingText={supportingText}
        disabled={disabled}
        selected={selected}
        onSelect={onSelect}
        showSelect={showSelect}
      />
    ))
  );

  return (
    <div className={clsx('checkbox-group-cont', className)}>
      {getView()}
    </div>
  );
};

CheckboxGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    renderIcon: PropTypes.func,
    image: PropTypes.string,
    text: PropTypes.string,
    supportingText: PropTypes.string,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
  })),
  onSelect: PropTypes.func,
  showSelect: PropTypes.bool,
  className: PropTypes.string,
};

CheckboxGroup.defaultProps = {
  items: [],
  onSelect: () => {},
  showSelect: true,
  className: '',
};

export {
  CheckboxGroup as default,
  CheckboxGroupItem,
};
